import { Loader } from "@components/loader/loader";
import { PressGrid } from "@components/press_grid/press_grid";
import { useFetchPressItems } from "@hooks/use_fetch_press_items";
import React, { type FC } from "react";

const PressIndexPage: FC = () => {
  const { pressItems, loading } = useFetchPressItems();

  if (loading) {
    return <Loader />;
  }
  if (!pressItems) {
    return null;
  }

  return (
    <>
      <header className="press-page--header">
        <h1>Press</h1>
      </header>
      <section className="press">
        <PressGrid pressItems={pressItems} />
      </section>
    </>
  );
};

export { PressIndexPage };
